<template>
  <div class="not-found">
    <img src="@/assets/images/common/404.png">
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  data() {
    return {};
  },
  mounted() {
  },

};
</script>
<style lang="scss" scoped>
.not-found{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
